<div [class.floating-div]="isFloating"
  [ngStyle]="{
    top: positionTop,
    width: divWidth,
    left: positionLeft,
    right: positionRight
  }"
>
  <div>{{ title }}</div>
  <ng-container *ngIf="ShowOptions === true;">
    <div class="flex-container" id="divFeedbackButtons">
      <div>
        <button (click)="FeedbackClick(5);$event.preventDefault();">
          <img [src]="HappyImageUrl" [alt]="HappyImageAlt" />
        </button>
      </div>
      <div>
        <button (click)="FeedbackClick(4);$event.preventDefault();">
          <img [src]="OKImageUrl" [alt]="OKImageAlt" />
        </button>
      </div>
      <div>
        <button (click)="FeedbackClick(3);$event.preventDefault();">
          <img [src]="NeutralImageUrl" [alt]="NeutralImageAlt" />
        </button>
      </div>
      <div>
        <button (click)="FeedbackClick(2);$event.preventDefault();">
          <img [src]="SadImageUrl" [alt]="SadImageAlt" />
        </button>
      </div>
      <div>
        <button (click)="FeedbackClick(1);$event.preventDefault();">
          <img [src]="VerySadImageUrl" [alt]="VerySadImageAlt" />
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="ShowComment === true;">
    <div id="divComment">
      Please leave some comments<br/>
      <textarea [(ngModel)]="CommentText" rows="3" id="txtComment"></textarea>
      <button (click)="SaveComment();$event.preventDefault();">Submit Feedback</button>
    </div>
  </ng-container>
  <ng-container *ngIf="ShowThankYou === true;">
    <div id="divFeedbackThankYou">
      <h3>Thank You for your feedback</h3>
    </div>
  </ng-container>
</div>
